import React from 'react';
import ThemeSelector from './ThemeSelector';

interface MobileTopNavProps {
  setActiveModal: (modal: 'instrument' | 'scale' | 'chord' | 'settings' | null) => void;
}

export const MobileTopNav: React.FC<MobileTopNavProps> = ({setActiveModal}) => {
  return (
    // <div className='md:hidden absolute w-full bg-base-300'>
    //   <h1 className="text-lg font-bold float-start absolute top-2 left-2 w-full ">
    //     String Wizard <span className="indicator-item badge badge-primary border-base-300 bg-base-300 text-base-content h-full align-middle text-xs">Beta</span>
    //   </h1>
    //   <div className='absolute right-0'>
    //     <ThemeSelector />
    //   </div>
    // </div>

    <div className="navbar bg-base-100 md:hidden z-100 py-0 min-h-1">
      <div className="navbar-start">
        <a className="btn btn-ghost text-lg">
          <h1 className="text-lg font-bold">
            String Wizard <span className="indicator-item badge badge-primary h-full align-middle text-xs">Beta</span>
          </h1>
        </a>
      </div>
      <div className="navbar-end">
      {/* <ThemeSelector /> */}
        <button className="btn btn-ghost btn-circle" onClick={() => setActiveModal('settings')}>
          <svg className='w-7 h-7' xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        </button>
      </div>
    </div>
  );
};